import styled from "styled-components";

export const Container = styled.div`
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

    background-color: #0D1117;
`;

export const Content = styled.div`
    width: 100%;
    max-width: 70%;
    height: 100%;
    
    margin: 0 auto;
    padding: 0 auto;
    box-sizing: border-box;
`;